import React from "react"
import { Button } from "@material-ui/core"
import SaveAltIcon from "@material-ui/icons/SaveAlt";
const DownloadXLSAssetDetail = ({ exportReportFn, files ,color,variant,size}) => {
	const handleClose = (event, files, triggerExport) => {
		if (triggerExport) {
			exportReportFn(files)
		}
	}

	return (
		<>
			<Button
				onClick={(event) => handleClose(event, files, "triggerExport")}
				files={{ title: "XLSX", extension: "xls", key: "" }}
				style={{color:color}}
				variant={variant? variant : ''}
				size={size ? size :""}
			>
				<SaveAltIcon style={{fontSize:'1.15rem'}}/>
				{files.extension === "docx"}
				{files.title}
			</Button>
		</>
	)
}

export default DownloadXLSAssetDetail
